import { ITaInitialState } from "../../../types/master/taInterface";
import { TaActionTypes } from "../../actionTypes/master/taActionTypes";
import { TaActions } from "../../actionTypes/master/taActionTypes";

const initialState: ITaInitialState = {
  taList: [],
  taData: {
    id: 0,
    ta_name: "",
    ta_code: "",
    email: "",
    contact_number: "",
    profile_status: "",
  },
  taListPageCount: 0,
};

export default function taReducer(state = initialState, action: TaActionTypes): ITaInitialState {
  switch (action.type) {
    case TaActions.SET_TA_LIST:
      return {
        ...state,
        taList: action.payload,
      };

    case TaActions.SET_TA_LIST_PAGE_COUNT:
      return {
        ...state,
        taListPageCount: action.payload,
      };

    case TaActions.SET_TA_DATA_BY_ID:
      return {
        ...state,
        taData: action.payload,
      };

    default:
      return state;
  }
}
